export const letterM = {
  nouns: [
    {"girl": ["Mädchen", "Mädchen", "das", "die", "n"]},
    {"man": ["Mann", "Männer", "der", "die", "m"]},
    {"machine": ["Maschine", "Maschinen", "die", "die", "f"]},
    {"sea": ["Meer", "Meere", "das", "die", "n"]},
    {"person": ["Mensch", "Menschen", "der", "die", "m"]},
    {"rent": ["Miete", "Mieten", "die", "die", "f"]},
    {"milk": ["Milch", "Milch", "die", "die", "f"]},
    {"middle": ["Mitte", "Mitten", "die", "die", "f"]},
    {"furniture": ["Möbel", "Möbel", "die", "die", "f"]},
    {"moment": ["Moment", "Momente", "der", "die", "m"]},
    {"mouth": ["Mund", "Münder", "der", "die", "m"]},
    {"mother": ["Mutter", "Mütter", "die", "die", "f"]}
  ],
  verbs: [
    {"to do, to make": ["machen", "mache", "machst", "macht", "macht", "macht", "machen", "macht", "machen", "machen"]},
    {"to rent": ["mieten", "mieste", "mietest", "mietet", "mietet", "mietet", "mieten", "mietet", "mieten", "mieten"]},
    {"to bring along": ["mitbringen", "bringe mit", "bringst mit", "bringt mit", "bringt mit", "bringt mit", "bringen mit", "bringt mit", "bringen mit", "bringen mit"]},
    {"to come along": ["mitkommen", "komme mit", "kommst mit", "kommt mit", "kommt mit", "kommt mit", "kommen mit", "kommt mit", "kommen mit", "kommen mit"]},
    {"to participate": ["mitmachen", "mache mit", "machst mit", "macht mit", "macht mit", "macht mit", "machen mit", "macht mit", "machen mit", "machen mit"]},
    {"to take along": ["mitnehmen", "nehme mit", "nimmst mit", "nimmt mit", "nimmt mit", "nimmt mit", "nehmen mit", "nehmt mit", "nehmen mit", "nehmen mit"]},
    {"to want": ["möchten", "möchte", "möchtest", "möchte", "möchte", "möchte", "möchten", "möchtet", "möchten", "möchten"]},
    {"to like": ["mögen", "mag", "magst", "mag", "mag", "mag", "mögen", "mögt", "mögen", "mögen"]},
    {"to have to, must": ["müssen", "muss", "musst", "muss", "muss", "muss", "müssen", "müsst", "müssen", "müssen"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Mädchen spielt.',
        english: 'The girl is playing.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Mann arbeitet.',
        english: 'The man is working.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Maschine ist neu.',
        english: 'The machine is new.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Meer ist blau.',
        english: 'The sea is blue.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Mensch kommt.',
        english: 'The person is coming.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Miete ist hoch.',
        english: 'The rent is high.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Milch ist frisch.',
        english: 'The milk is fresh.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Mitte ist schön.',
        english: 'The middle is beautiful.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Moment ist wichtig.',
        english: 'The moment is important.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Mund ist groß.',
        english: 'The mouth is big.',
        answer: 'Der',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich sehe ___ Mann.',
        english: 'I see the man.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie kauft ___ Maschine.',
        english: 'She buys the machine.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er braucht ___ Miete.',
        english: 'He needs the rent.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir trinken ___ Milch.',
        english: 'We drink the milk.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du erreichst ___ Mitte.',
        english: 'You reach the middle.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Ich habe ___ Moment.',
        english: 'I have the moment.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie sieht ___ Mund.',
        english: 'She sees the mouth.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er liebt ___ Mutter.',
        english: 'He loves the mother.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir kaufen ___ Möbel.',
        english: 'We buy the furniture.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du besuchst ___ Mädchen.',
        english: 'You visit the girl.',
        answer: 'das',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Mann.',
        english: 'I help the man.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie geht zu ___ Maschine.',
        english: 'She goes to the machine.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er spricht mit ___ Mensch.',
        english: 'He speaks with the person.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir danken ___ Mutter.',
        english: 'We thank the mother.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du sitzt in ___ Mitte.',
        english: 'You sit in the middle.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Ich gebe ___ Kind ___ Milch.',
        english: 'I give the child the milk.',
        answer: 'dem die',
        case: 'dative'
      },
      {
        german: 'Sie arbeitet für ___ Mann.',
        english: 'She works for the man.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Er kommt aus ___ Meer.',
        english: 'He comes from the sea.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir leben bei ___ Mutter.',
        english: 'We live with the mother.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du sprichst mit ___ Mädchen.',
        english: 'You speak with the girl.',
        answer: 'dem',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The man is working.',
        german: 'Der Mann arbeitet.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The girl is playing.',
        german: 'Das Mädchen spielt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She loves the mother.',
        german: 'Sie liebt die Mutter.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I help the man.',
        german: 'Ich helfe dem Mann.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'They live near the sea.',
        german: 'Sie leben am Meer.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The machine is good.',
        german: 'Die Maschine ist gut.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We make the furniture.',
        german: 'Wir machen die Möbel.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The person drinks the milk.',
        german: 'Der Mensch trinkt die Milch.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'You go to the middle.',
        german: 'Du gehst in die Mitte.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'He brings the book.',
        german: 'Er bringt das Buch.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The rent is high.',
        german: 'Die Miete ist hoch.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I want to rent the apartment.',
        german: ['Ich möchte die Wohnung mieten.','Ich will das Apartment mieten','Ich möchte das Apartment mieten','Ich will die Wohnung mieten.'],
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The moment is important.',
        german: 'Der Moment ist wichtig.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She sits in the middle.',
        german: 'Sie sitzt in der Mitte.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'We buy new furniture.',
        german: 'Wir kaufen neue Möbel.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The mother loves the child.',
        german: 'Die Mutter liebt das Kind.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I come along.',
        german: 'Ich komme mit.',
        type: 'translation',
        caseType: 'modal'
      },
      {
        english: 'The mother laughs.',
        german: 'Die Mutter lacht.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'You must help.',
        german: 'Du musst helfen.',
        type: 'translation',
        caseType: 'modal'
      },
      {
        english: 'The machine makes noise.',
        german: 'Die Maschine macht Lärm.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We rent the apartment.',
        german: 'Wir mieten die Wohnung.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'She brings the food.',
        german: 'Sie bringt das Essen mit.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'He comes along.',
        german: 'Er kommt mit.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'I take the book.',
        german: 'Ich nehme das Buch mit.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'They like the movie.',
        german: 'Sie mögen den Film.',
        type: 'translation',
        caseType: 'accusative'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to make" for "I"?',
        answer: 'mache',
        verb: 'machen',
        verbEnglish: 'to do, to make',
        subject: 'ich',
        conjugation: 'mache'
      },
      {
        question: 'How do you conjugate "to rent" for "you" (informal)?',
        answer: 'mietest',
        verb: 'mieten',
        verbEnglish: 'to rent',
        subject: 'du',
        conjugation: 'mietest'
      },
      {
        question: 'How do you conjugate "to bring along" for "he"?',
        answer: 'bringt mit',
        verb: 'mitbringen',
        verbEnglish: 'to bring along',
        subject: 'er',
        conjugation: 'bringt mit'
      },
      {
        question: 'How do you conjugate "to want" for "we"?',
        answer: 'möchten',
        verb: 'möchten',
        verbEnglish: 'to want',
        subject: 'wir',
        conjugation: 'möchten'
      },
      {
        question: 'How do you conjugate "to have to" for "they"?',
        answer: 'müssen',
        verb: 'müssen',
        verbEnglish: 'to have to, must',
        subject: 'sie',
        conjugation: 'müssen'
      },
      {
        question: 'What is the simple past of "to make" for "I"?',
        answer: 'machte',
        verb: 'machen',
        verbEnglish: 'to do, to make',
        subject: 'ich',
        conjugation: 'machte'
      },
      {
        question: 'What is the simple past of "to rent" for "she"?',
        answer: 'mietete',
        verb: 'mieten',
        verbEnglish: 'to rent',
        subject: 'sie',
        conjugation: 'mietete'
      },
      {
        question: 'What is the simple past of "to bring along" for "he"?',
        answer: 'brachte mit',
        verb: 'mitbringen',
        verbEnglish: 'to bring along',
        subject: 'er',
        conjugation: 'brachte mit'
      },
      {
        question: 'What is the simple past of "to come along" for "we"?',
        answer: 'kamen mit',
        verb: 'mitkommen',
        verbEnglish: 'to come along',
        subject: 'wir',
        conjugation: 'kamen mit'
      },
      {
        question: 'What is the simple past of "to take along" for "they"?',
        answer: 'nahmen mit',
        verb: 'mitnehmen',
        verbEnglish: 'to take along',
        subject: 'sie',
        conjugation: 'nahmen mit'
      },
      {
        question: 'How do you conjugate "to like" for "I"?',
        answer: 'mag',
        verb: 'mögen',
        verbEnglish: 'to like',
        subject: 'ich',
        conjugation: 'mag'
      },
      {
        question: 'How do you conjugate "to participate" for "she"?',
        answer: 'macht mit',
        verb: 'mitmachen',
        verbEnglish: 'to participate',
        subject: 'sie',
        conjugation: 'macht mit'
      },
      {
        question: 'What is the simple past of "to participate" for "we"?',
        answer: 'machten mit',
        verb: 'mitmachen',
        verbEnglish: 'to participate',
        subject: 'wir',
        conjugation: 'machten mit'
      },
      {
        question: 'What is the simple past of "to take along" for "I"?',
        answer: 'nahm mit',
        verb: 'mitnehmen',
        verbEnglish: 'to take along',
        subject: 'ich',
        conjugation: 'nahm mit'
      },
      {
        question: 'What is the simple past of "to like" for "she"?',
        answer: 'mochte',
        verb: 'mögen',
        verbEnglish: 'to like',
        subject: 'sie',
        conjugation: 'mochte'
      },
      {
        question: 'What is the simple past of "to have to" for "we"?',
        answer: 'mussten',
        verb: 'müssen',
        verbEnglish: 'to have to, must',
        subject: 'wir',
        conjugation: 'mussten'
      }
    ]
  }
}
